//deps
import React from 'react';
import { withStyles } from 'tss-react/mui'
import { Router, Route } from 'react-router-dom'

// services
import { history } from './services/history'
import { authenticationService } from './services/auth_service';
import { userService } from './services/user_functions';
import { userType } from './services/const'
import { PrivateRoute } from './PrivateRoute';

//header & footer
import Header from './Header'
import Footer from './Footer';

//rotas
import Home from './home';
import Callback from './Callback' // Para desabilitar familia comentar essa linha
import Family from './Family';
import FamilyLoginGovBr from './FamilyLoginGovBr' // Para desabilitar familia comentar essa linha
import EmployeeLogin from './EmployeeLogin';
import Employee from './Employee';
import Admin from './Admin';
import NewEmployee from './NewEmployee';
import Dashboard from './Dashboard';
import Log from './Log';
import Terms from './Terms';
import About from './About';
import NotConnected from './NotConnected'
import UpdateEmployeePassword from './UpdateEmployeePassword';
import UpdateAdminPassword from './UpdateAdminPassword';
import PasswordRecovery from './PasswordRecovery/PasswordRecovery';

/*to do: alterar a forma de login: https://medium.com/better-programming/building-basic-react-authentication-e20a574d5e71 
https://medium.com/@ruthmpardee/passing-data-between-react-components-103ad82ebd17
https://jasonwatmore.com/post/2019/02/01/react-role-based-authorization-tutorial-with-example
*/
const useStyles = (theme, props) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // marginBottom, theme.spacing(1),

  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  main: {
    minHeight: '92vh',
    paddingBottom: '60px',
    padding: '27px',
  },
  container: {
    minHeight: '100%',
    position: 'relative',
  }
})


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      role: userType.NONE,
      connected: true,
    }
    userService.testConnection().catch(e => {
      this.setState({ connected: false, })
    })
  }

  
  //UNSAFE_componentWillMount() {
  UNSAFE_componentWillMount() {
    authenticationService.currentUser.subscribe(x => {
      if (x && x.user_data) {
        this.setState({
          user: x.user_data,
        })
      }
    })
  }

  logout() {
    authenticationService.logout();
    history.push('/');
  }
  render() {
    const { classes } = this.props;

    return (
      <Router history={history}>
      {/* <React.StrictMode>  */}
          <div className={classes.container}>
            <Header userData={this.state.user} />
            <div className={classes.main}>
              <Route path="/" exact={true}  component={this.state.connected ? (() => <Home userData={this.state.user} />) : NotConnected} />
              <Route path="/LoginFamiliaGovBr" component={this.state.connected ?  (() => <FamilyLoginGovBr userData={this.state.user} />) : NotConnected} />
              <Route path="/LoginFuncionario" component={this.state.connected ? (() => <EmployeeLogin userData={this.state.user} />) : NotConnected} />
              <Route path="/Callback" component={Callback} />
              <PrivateRoute path="/Funcionario" role={userType.EMPLOYEE} userData={this.state.user}
                component={this.state.connected ? Employee : NotConnected}/>
              <PrivateRoute path="/Admin" role={userType.ADMIN} userData={this.state.user} component={this.state.connected ? Admin : NotConnected} />
              <PrivateRoute path="/Familia" role={userType.FAMILY} userData={this.state.user} component={this.state.connected ? Family : NotConnected} />
              <PrivateRoute path="/FuncionarioNovo" role={userType.ADMIN} userData={this.state.user} component={this.state.connected ? NewEmployee : NotConnected} />
              <PrivateRoute path="/AlterarSenhaFuncionario" role={userType.EMPLOYEE} userData={this.state.user} component={this.state.connected ? UpdateEmployeePassword : NotConnected} />
              <PrivateRoute path="/AlterarSenhaAdmin" role={userType.ADMIN} userData={this.state.user} component={this.state.connected ? UpdateAdminPassword : NotConnected} />
              <PrivateRoute path="/Log" role={userType.ADMIN} userData={this.state.user} component={this.state.connected ? Log : NotConnected} />
              <PrivateRoute path="/Dashboard" role={userType.ADMIN} userData={this.state.user} component={this.state.connected ? Dashboard : NotConnected} />

              <Route path="/Termos" component={this.state.connected ? Terms : NotConnected} />
              <Route path="/Sobre" component={this.state.connected ? (()=> <About userData={this.state.user}/>) : NotConnected} />
              <Route path="/RecuperarSenha" component={this.state.connected ? PasswordRecovery : NotConnected} />
            </div>
            <Footer />
          </div>
      {/* </React.StrictMode> */}
      </Router>

    );
  }
}
//<PrivateRoute path="/Privacidade" role={userType.FAMILY} userData={this.state.user} component={this.state.connected ? Privacy: NotConnected} />
export default withStyles(App, useStyles);
